import { Component, Input } from '@angular/core';
import { MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { combineInput } from '@app/new-ui/analysis/analysis.component';
import { combineLatest, firstValueFrom, map } from 'rxjs';
import { DataIntervalTagEditDialog } from '@app/shared/edit-dialog/data-interval-tag/data-interval-tag-edit-dialog.component';
import { Observable } from 'rxjs';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { fragQuery } from '@models';
import { op } from '@lib/rxjs';
import { DialogService } from '../dialog.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationRoute$ } from '@injectables';

@Component({
    selector: 'app-dialog-muckpile-tagging',
    templateUrl: './dialog-muckpile-tagging.component.html',
    styleUrls: ['./dialog-muckpile-tagging.component.scss']
})
export class DialogMuckpileTaggingComponent {
    static readonly config: MatDialogConfig<Input> = {
        autoFocus: false,
        disableClose: true,
    };
    static readonly output: boolean;

    constructor(
        private readonly host: MatDialogRef<DataIntervalTagEditDialog, boolean>,
        private readonly fragQuery: FragQueryService,
        private dialog: DialogService,
        private readonly route: ActivatedRoute,
        private readonly route$: NavigationRoute$,
    ) { }
    public readonly muckpiles$ = this.fragQuery.muckpiles$.pipe(
        map(muckpiles => muckpiles ? muckpiles.filter(m => m.isActive) : [])
    );
    public readonly muckpile$ = this.fragQuery.muckpile$;

    public readonly dataIntervals$: Observable<fragQuery.timeline.sieveSizesAtPercents.Interval[]> = combineLatest([
        this.fragQuery.timelineSieveSizesAtPercents$,
        this.fragQuery.addOnTimelineSieveSizesAtPercents$
    ]).pipe(
        op.debounceTime(0),
        op.tap(([input, addOn]) => combineInput(input, addOn, this.fragQuery.addDataAt.value)),
        op.map(([input]) => {
            if (input && input.intervals) {
                return input.intervals.filter(interval => interval.muckpileId === null);
            } else
                return null
        }),
        op.shareReplay(1)
    );

    public readonly type$ = this.route$
        .pipe(op.map(route => route[0]));

    public selectedRecords = new Set<fragQuery.timeline.sieveSizesAtPercents.Interval>;

    public async selectAll(v: boolean) {
        if (v) {
            const records = await firstValueFrom(this.dataIntervals$);
            for (const record of records)
                this.selectedRecords.add(record);
        } else {
            this.selectedRecords.clear();
        }
    }

    public async selectRecord(selected: boolean, record: fragQuery.timeline.sieveSizesAtPercents.Interval) {
        if (selected) {
            this.selectedRecords.add(record);
        } else {
            this.selectedRecords.delete(record);
        }
    }

    public valid() {
        if (this.selectedRecords.size) {
            return true;
        } else {
            return false;
        }
    }

    public cancel() {
        this.host.close(false);
    }

    public async tag() {
        const dataIntervalIds = this.selectedRecords.map(interval => {
            return interval.id
        })

        const muckpile = await firstValueFrom(this.muckpile$);
        const muckpileId = muckpile?.id;

        if (await this.dialog.confirm({ message: `The action is irreversible, Are you sure to tag the selected ${dataIntervalIds.size} data intervals ?` })) {
            await this.dialog.await(this.fragQuery.taggingMuckpile([...dataIntervalIds], muckpileId));
            this.dialog.closeAll()
        };
    }
}
